import tabs from "../../../utils/tabs/tab.js";

const blogGroup = () => {

    tabs()

}

export default blogGroup;